<template>
  <section
    class="component-d4bef2ce"
    resmed-component-name="faq_icon-line_text"
    v-bind:style="{
      background: acf.layout['background'],
      'padding-top': acf.layout['padding-top'],
      'padding-bottom': acf.layout['padding-bottom'],
    }"
    v-bind:data-step="acf.steps.next && acf.steps.next - 1"
    v-bind:id="[`${acf.layout['id']}`]"
  >
    <div
      class="component"
      v-bind:class="[`text-align-${acf.layout['alignment']}`]"
    >
      <div class="container px-xs-sm-2">
        <div class="row justify-content-center">
          <div
            v-bind:class="{
              'col-md-10 col-lg-7 col-xl-8':
                acf.layout['alignment'] === 'center',
              'col-md-9': acf.layout['alignment'] === 'left',
            }"
          >
            <h5 style="font-size: 1.3rem; font-weight: 600; line-height: 1.3;" v-if="acf.steps.step" class="step">{{ acf.steps.step }}</h5>
            <eyebrow-icon
              v-if="acf.eyebrowicon"
              v-bind:eyebrowicon="acf.eyebrowicon"
              v-bind:align="
                acf.layout['alignment'] === 'center' ? 'center' : ''
              "
            ></eyebrow-icon>
            <h2 style="font-size: 2.5rem; font-weight: 400; line-height: 1.4;" v-if="acf.headline">{{ acf.headline }}</h2>
          </div>
        </div>
        <div class="row justify-content-center">
          <div
            class="col-md-9"
            v-bind:class="{
              'text-center': acf.layout['alignment'] === 'center',
            }"
          >
            <div
              class="description"
              v-if="acf.description"
              v-html="acf.description"
            ></div>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-md-9">
            <reveal-faq v-bind:items="acf.items"></reveal-faq>
            <pro-tip
              v-if="acf['healthcare-pro-tip'].excerpt"
              v-bind:acf="acf['healthcare-pro-tip']"
            ></pro-tip>
          </div>
        </div>

        <!-- call to action and steps -->
        <div
          class="row justify-content-center"
          v-if="acf.cta.href || acf.steps.next"
        >
          <div class="col-md-9 cta-steps">
            <a
              v-if="acf.cta.href"
              v-bind:href="acf.cta.href"
              class="btn cta-pill filled-red icon right-arrow mb-2 mr-2"
              v-bind:target="acf.cta.target"
              >{{ acf.cta.text }}</a
            >
            <a
              v-if="acf.steps.step"
              v-bind:href="'#'"
              v-on:click.prevent="next(acf.steps.next)"
              class="btn cta-pill hallow-red icon right-arrow"
              >Next step</a
            >
          </div>
        </div>
      </div>

      <div class="mt-3">
        <steps-fcbecf18
          v-if="acf.steps.step"
          v-bind:acf="acf.steps"
        ></steps-fcbecf18>
      </div>
    </div>
  </section>
</template>

<script>
import revealFaq from "../shared-support/reveal-faq";
import stepsFcbecf18 from "../shared-support/steps-fcbecf18";
import { scroll } from "../../mixins/index";
import proTip from "../shared-support/healthcare-pro-tip";

export default {
  name: "component-d4bef2ce", // faq_icon-line_text
  props: ["acf"],
  components: {
    revealFaq,
    stepsFcbecf18,
    proTip,
  },
  mixins: [scroll],
  methods: {
    next(arg) {
      this.$nextTick(() => {
        this.scroll({
          to: `[data-step='${arg}']`,
          offset: ["xs", "sm", "md"].includes(this.$root.mode) && 90,
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-d4bef2ce {
  padding: 6rem 0 3rem 0;
  background-size: cover;
}

.component {
  ul {
    padding-left: 3rem;
  }

  h2 {
    position: relative;
  }

  h5 {
    &.step {
      margin: 0 0 2.25rem 0;

      &:before {
        top: 2.25rem;
      }
    }

    ~ h2 {
      &:before {
        top: -1.325rem !important;
      }
    }
  }

  &.text-align-center {
    h2 {
      text-align: center;
      @extend %eyebrow-center;
    }
  }

  &.text-align-left {
    h2 {
      @extend %eyebrow-left;
    }
  }

  .items {
    display: flex;
    justify-content: center;

    .item {
      padding: 1rem 1.5rem;

      figure {
        max-width: 3rem;
        margin: 0 auto 1rem auto;

        img {
          display: block;
        }
      }
    }
  }

  .cta-steps {
    a {
      &:last-child {
        margin-bottom: 0 !important;
        margin-right: 0 !important;
      }
    }
  }
}
</style>
